export default class MapMaker {

	static createDynamicMap(element) {

		let map = new google.maps.Map(element, {
			zoom: 10,
			clickableIcons: false,
			streetViewControl: false,
			mapTypeControl: false,
			fullscreenControl: false,
			zoomControl: false,
			gestureHandling: "cooperative",
			mapId: mcArgs.gmapMapId
		});

		map.bounds = new google.maps.LatLngBounds();
		map.markers = [];
		this.zoomControls(element, map);
		return map;

	}

	static createStaticMap(element, markers) {

		let imgWidth = "640";
		let imgHeight = "640";
		if (element.classList.contains('map-fullwidth')) {
			imgHeight = "360";
		}

		let url = "https://maps.googleapis.com/maps/api/staticmap?";
		url += "key=" + mcArgs.gmapApiKey;
		url += "&map_id=" + mcArgs.gmapMapId;
		url += "&size=" + imgWidth + "x" + imgHeight;
		url += "&scale=2";
		url += "&format=JPEG";

		if (markers.length === 1) {
			url += "&center=" + markers[0].dataset.markerLat + "," + markers[0].dataset.markerLng;
			url += "&zoom=" + element.dataset.zoom;
		}

		markers.forEach((marker) => {
			url += "&markers=";
			url += marker.dataset.markerLat + "," + marker.dataset.markerLng;
			if (marker.dataset.pointer) {
				url += "|icon:" + encodeURI(marker.dataset.pointer);
			}
		});

		let image = new Image();
		image.src = url;
		image.width = imgWidth;
		image.height = imgHeight;
		element.appendChild(image);

	}

	static zoomControls(element, map) {
		let zoomIn = element.closest('.map-container').querySelector('.map-zoom-in');
		if (zoomIn) {
			zoomIn.addEventListener('click', () => {
				map.setZoom(map.getZoom() + 1);
			});
		}

		let zoomOut = element.closest('.map-container').querySelector('.map-zoom-out');
		if (zoomOut) {
			zoomOut.addEventListener('click', () => {
				map.setZoom(map.getZoom() - 1);
			});
		}
	}

	static createMarker(marker, map) {
		let m = new google.maps.marker.AdvancedMarkerElement({
			map,
			position: {
				lat: parseFloat(marker.dataset.markerLat),
				lng: parseFloat(marker.dataset.markerLng)
			}
		});

		let glyphImg = null;
		if (marker.dataset.pointer) {
			glyphImg = document.createElement('img');
			glyphImg.src = marker.dataset.pointer;
			let s = marker.dataset.pointerSize.split('x');
			glyphImg.style.width = s[0]+"px";
			glyphImg.style.height = s[1]+"px";

			m.content = glyphImg;
		}

		map.markers.push(m);
		map.bounds.extend(m.position);
	}

	static updateBounds(map) {
		if (map.markers.length > 1) {
			map.fitBounds(map.bounds);
		} else {
			map.setCenter(map.markers[0].position);
		}
	}
}
